"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var stretch_1 = require("../systems/stretch");

var spacing_1 = require("../systems/spacing");

var scales_1 = require("../constants/scales");

var palette_1 = require("../constants/palette");

var Button = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: color .2s, background-color .2s, box-shadow .2s, border-color .2s;\n  background-color: #54bfda;\n  color: ", ";\n  text-transform: ", ";\n  display: inline-block;\n  cursor: pointer;\n  border: 1px solid transparent;\n  font-weight: 600;\n  font-size: ", ";\n  border-radius: 4px;\n  padding: ", "em ", "em;\n  &:hover {\n    background-color: #1c7f98;\n  }\n  @supports (-webkit-overflow-scrolling: touch) {\n    &:hover {\n      background-color: #54bfda;\n    }\n  }\n  &:focus {\n    border-color: #3195ce;\n    outline: 0;\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(49,149,206,.8);\n  }\n  ", "\n  ", "\n  ", "\n  &:disabled {\n    color: ", ";\n    border: 1px solid transparent;\n    cursor: default;\n    background: repeating-linear-gradient(\n      -45deg,\n      ", ",\n      ", " 8px,\n      ", " 8px,\n      ", " 16px\n    );\n  }\n  ", ";\n"], ["\n  transition: color .2s, background-color .2s, box-shadow .2s, border-color .2s;\n  background-color: #54bfda;\n  color: ", ";\n  text-transform: ", ";\n  display: inline-block;\n  cursor: pointer;\n  border: 1px solid transparent;\n  font-weight: 600;\n  font-size: ", ";\n  border-radius: 4px;\n  padding: ", "em ", "em;\n  &:hover {\n    background-color: #1c7f98;\n  }\n  @supports (-webkit-overflow-scrolling: touch) {\n    &:hover {\n      background-color: #54bfda;\n    }\n  }\n  &:focus {\n    border-color: #3195ce;\n    outline: 0;\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(49,149,206,.8);\n  }\n  ", "\n  ", "\n  ", "\n  &:disabled {\n    color: ", ";\n    border: 1px solid transparent;\n    cursor: default;\n    background: repeating-linear-gradient(\n      -45deg,\n      ", ",\n      ", " 8px,\n      ", " 8px,\n      ", " 16px\n    );\n  }\n  ", ";\n"])), palette_1.default.white, function (props) {
  return props.preventUppercase ? 'none' : 'uppercase';
}, function (props) {
  return props.large ? '15px' : '13px';
}, scales_1.responsive['8'], scales_1.responsive['16'], function (props) {
  return props.inverse && "\n    color: #54bfda;\n    background-color: " + palette_1.default.white + ";\n    &:hover {\n      color: #54bfda;\n      background-color: " + palette_1.default.lightGrey + ";\n    }\n  ";
}, function (props) {
  return props.ghost && "\n    color: #54bfda;\n    background-color: transparent;\n    border-color: #54bfda;\n    &:hover {\n      color: #02659e;\n      border-color: #02659e;\n      background-color: transparent;\n    }\n  ";
}, function (props) {
  return props.ghost && props.inverse && "\n    color: " + palette_1.default.white + ";\n    border-color: " + palette_1.default.white + ";\n    &:hover {\n      color: " + palette_1.default.lightGrey + ";\n      border-color: " + palette_1.default.lightGrey + ";\n    }\n  ";
}, palette_1.default.white, palette_1.default.medGrey, palette_1.default.medGrey, palette_1.default.altMedGrey, palette_1.default.altMedGrey, function (props) {
  return __assign({}, stretch_1.default(props), spacing_1.default(props));
});
exports.default = Button;
var templateObject_1;